// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sKyp6","column":"styles_column__4jMBu","item":"styles_item__K4+Gg"};